import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

// Google Maps Components:
import { AgmCoreModule } from '@agm/core';

// Files Related to Side Menu:
import { SideMenuContentComponent } from '../shared/side-menu-content/side-menu-content.component';

// Files related to Image upload and Webcam:  
import { ImageCropperModule } from 'ngx-image-cropper';
import { FileHelpersModule } from 'ngx-file-helpers'; 
import { FileDropzoneComponent } from '../components/file-dropzone/file-dropzone';
import {WebcamModule} from 'ngx-webcam';

//Services
import { ExcelService } from '../services/excel.services';
import {MysqlService} from '../services/mysql.service';
import {EncryptionService} from '../services/encryption.service';
import { ImcpaAppProvider } from '../providers/imcpaApp/imcpaApp';

import { MyApp } from './app.component';

import { LoginPage } from '../pages/login/login';
import { TabsPage } from '../pages/tabs/tabs';
import { GlobalPage } from '../pages/global/global';
import { HomePage } from '../pages/home/home';
import { DashboardPage } from '../pages/dashboard/dashboard/dashboard';
import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';

import { CampaignListPage } from '../pages/campaigns/campaignList/campaignList';
import { CampaignDashboardPage } from '../pages/campaigns/campaignDashboard/campaignDashboard';
import { AddCampaignPage } from '../pages/campaigns/addCampaign/addCampaign';

import { ResourcesListPage } from '../pages/resources/resourceList/resourcesList';
import { ViewResourcePage } from '../pages/resources/viewResource/viewResource';

import { CertificatePage } from '../pages/certificate/certificate/certificate';
import { CertificateModalPage } from '../pages/certificate/certificateModal/certificateModal';

import { FarmListPage } from '../pages/farms/farmList/farmList';
import { FarmDashboardPage } from '../pages/farms/farmDashboard/farmDashboard';
import { AddFarmPage } from '../pages/farms/addFarm/addFarm';

import { CowDashboardPage } from '../pages/cows/cowDashboard/cowDashboard';
import { UpdateCowPage } from '../pages/cows/updateCow/updateCow';

@NgModule({
  declarations: [
    MyApp,
    SideMenuContentComponent,
    FileDropzoneComponent,
    
    LoginPage,
    TabsPage,
    HomePage,
    DashboardPage,
    GlobalPage,
    AboutPage,
    ContactPage,

    FarmListPage,
    FarmDashboardPage,
    AddFarmPage,

    CampaignListPage,
    CampaignDashboardPage,
    AddCampaignPage,

    ResourcesListPage,
    ViewResourcePage,

    CertificatePage,
    CertificateModalPage,    

    CowDashboardPage,
    UpdateCowPage,
     
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    ImageCropperModule,
    FileHelpersModule,
    WebcamModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBAAwcL0UHj5ONipvHzP_LrVHesfrw5i6g'
    }),
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    
    LoginPage,
    TabsPage,
    HomePage,
    DashboardPage,
    GlobalPage,
    AboutPage,
    ContactPage,

    FarmListPage,
    FarmDashboardPage,
    AddFarmPage,

    CampaignListPage,
    CampaignDashboardPage,
    AddCampaignPage,

    ResourcesListPage,
    ViewResourcePage,

    CertificatePage,
    CertificateModalPage,

    CowDashboardPage,
    UpdateCowPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ExcelService, 
    MysqlService,
    EncryptionService,
    ImcpaAppProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts